export default {
  root: {
    width: '860px',
    height: '440px',
    display: 'flex',
    justifyContent: 'space-around',
    padding: '30px'
  }
};
